import styled from 'styled-components';
import { Grid, Flex } from '@chakra-ui/react';
export const Container = styled(Grid)`
  width: 100%;
  height: 100vh;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr 1fr;
  grid-gap: 1rem;
`;

export const ContainerCharts = styled(Flex)`
  border: 1px solid ${({ theme }) => theme.colors.gray100};
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  flex-direction: column;
  padding: 32px;
`;

export const HeaderContaienr = styled.header`
  width: 100%;
  height: auto;

  legend {
    font-weight: 700;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.tertiary};
    user-select: none;
  }
`;

export const ContentCharts = styled(Flex)`
  height: 100%;
`;
